//important base code in which all the code is there
import React, { useState, useEffect, Component } from "react";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import "./ViewPayslip.css";
import axios from "axios";
import Constant from "../../utils/constant";
import Button from "react-bootstrap/Button";
// function ViewPayslip({ payslip }) {
//   return (
//     <div className="p-3">
//       <h5 className="mb-3">Payslip for {payslip.month}</h5>
//       <table className="table table-bordered">
//         <tbody>
//           <tr>
//             <th>Employee Name</th>
//             <td>{payslip.employee_name}</td>
//           </tr>
//           <tr>
//             <th>Employee ID</th>
//             <td>{payslip.employee_id}</td>
//           </tr>
//           <tr>
//             <th>Month</th>
//             <td>{payslip.month}</td>
//           </tr>
//           <tr>
//             <th>Base Salary</th>
//             <td>{payslip.base_salary}</td>
//           </tr>
//           <tr>
//             <th>HRA</th>
//             <td>{payslip.hra}</td>
//           </tr>
//           <tr>
//             <th>Conveyance</th>
//             <td>{payslip.conveyance}</td>
//           </tr>
//           <tr>
//             <th>Special Allowance</th>
//             <td>{payslip.special_allowance}</td>
//           </tr>
//           <tr>
//             <th>Gross Salary</th>
//             <td>{payslip.gross_salary}</td>
//           </tr>
//           <tr>
//             <th>PF</th>
//             <td>{payslip.pf}</td>
//           </tr>
//           <tr>
//             <th>ESI</th>
//             <td>{payslip.esi}</td>
//           </tr>
//           <tr>
//             <th>CTC</th>
//             <td>{payslip.ctc}</td>
//           </tr>
//           <tr>
//             <th>Work Days</th>
//             <td>{payslip.work_days}</td>
//           </tr>
//           <tr>
//             <th>Leave Days</th>
//             <td>{payslip.leave_days}</td>
//           </tr>
//           <tr>
//             <th>Unpaid Leave Days</th>
//             <td>{payslip.unpaid_leave_days}</td>
//           </tr>
//           <tr>
//             <th>Leave Type</th>
//             <td>{payslip.leave_type}</td>
//           </tr>
//           <tr>
//             <th>Total Deductions</th>
//             <td>{payslip.deductions}</td>
//           </tr>
//           <tr>
//             <th>Net Pay</th>
//             <td>{payslip.net_pay}</td>
//           </tr>
//           <tr>
//             <th>Generated On</th>
//             <td>{new Date(payslip.created_at).toLocaleString()}</td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// }

const ViewPayslip = ({ payslip }) => {
  return (
    <div className="payslip-container">
      <h2>Employee Payslip</h2>

      <div className="payslip-section">
        <strong>Name:</strong> {payslip.employee_name}
      </div>
      <div className="payslip-section">
        <strong>Employee ID: </strong> {payslip.employee_id}
      </div>
      <div className="payslip-section">
        <strong>Month:</strong> {payslip.month}
      </div>
      {/* <div className="payslip-section">
        <strong>Leave Type:</strong> {payslip.leave_type}
      </div>
      <div className="payslip-section">
        <strong>Work Days:</strong> {payslip.work_days}
      </div>
      <div className="payslip-section">
        <strong>Leave Days:</strong> {payslip.leave_days}
      </div>
      <div className="payslip-section">
        <strong>Unpaid Leave Days:</strong> {payslip.unpaid_leave_days}
      </div> */}

      <hr />

      <table className="payslip-table">
        <thead>
          <tr>
            <th>Earnings</th>
            <th>Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Basic Salary</td>
            <td>{payslip.base_salary}</td>
          </tr>
          <tr>
            <td>HRA</td>
            <td>{payslip.hra}</td>
          </tr>
          <tr>
            <td>Conveyance</td>
            <td>{payslip.conveyance}</td>
          </tr>
          <tr>
            <td>Special Allowance</td>
            <td>{payslip.special_allowance}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>Gross Salary</th>
            <th>{payslip.gross_salary}</th>
          </tr>
        </tfoot>
      </table>

      <br />

      <table className="payslip-table">
        <thead>
          <tr>
            <th>Deductions</th>
            <th>Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PF</td>
            <td>{payslip.pf}</td>
          </tr>
          <tr>
            <td>ESI</td>
            <td>{payslip.esi}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>Total Deductions</th>
            <th>{payslip.deductions}</th>
          </tr>
          <tr>
            <th>Net Pay</th>
            <th>{payslip.net_pay}</th>
          </tr>
          <tr>
            <th>CTC</th>
            <th>{payslip.ctc}</th>
          </tr>
        </tfoot>
      </table>

      <div className="payslip-section mt-3">
        <strong>Generated On:</strong>{" "}
        {new Date(payslip.created_at).toLocaleString()}
      </div>

      <div className="payslip-footer">
        <p>
          <strong>Note:</strong> This is a system-generated payslip and does not
          require a signature.
        </p>
      </div>
    </div>
  );
};

function CalculateSalary() {
  const location = useLocation();
  const [workDays, setWorkDays] = useState("");
  const [leaveDays, setLeaveDays] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [showPayslipModal, setShowPayslipModal] = useState(false);
  const [payslipData, setPayslipData] = useState(null);
  const [month, setMonth] = useState("");
  const [unpaidLeaveDays, setunpaidLeaveDays] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  console.log("📦 location.state:", location.state);

  // Extract deeply if structure exists
  const passedEmployee = location.state?.employee?.employeeData;
  const workingCompany = location.state?.employee?.workingCompany;
  const familyDetail = location.state?.employee?.familyData;

  const employeeId = passedEmployee?.employee_id;

  console.log("🆔 Employee ID:", employeeId);

  const [employeeData, setEmployeeData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    if (passedEmployee) {
      setEmployeeData(passedEmployee);
      setSelectedStatus(passedEmployee.status || "");
    } else {
      console.error("❌ No employee data in location.state.");
    }
  }, [passedEmployee]);
  const handleCalculateSalary = async () => {
    if (!employeeData) return;

    const payload = {
      employee_id: employeeData.employee_id,
      employee_name: `${employeeData.first_name} ${employeeData.last_name}`,
      month: selectedMonth,
      base_salary: employeeData.basic_salary,
      work_days: parseInt(workDays),
      leave_days: parseInt(leaveDays),
      hra: employeeData.hra,
      conveyance: employeeData.conveyance,
      special_allowance: employeeData.special_allowance,
      pf: employeeData.provident_fund,
      esi: employeeData.ESI,
      leave_type: leaveType,
      unpaid_leave_days: parseInt(unpaidLeaveDays),
    };

    try {
      const response = await fetch(
        "https://api.policicue.com/hrms/calculatePayroll",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.status === 1) {
        alert("✅ Salary calculated successfully!");
        console.log("💰 Payroll Response:", result);
      } else {
        alert("❌ Failed to calculate salary.");
      }
    } catch (error) {
      console.error("❌ Error while calling salary API:", error);
      alert("Something went wrong.");
    }
  };
  const handleViewPayslip = async () => {
    if (!employeeData) return;

    const response = await fetch(
      `https://api.policicue.com/hrms/viewPayslip?employee_id=${employeeData.employee_id}&month=${selectedMonth}`
    );
    const result = await response.json();

    if (result.status === 1) {
      setPayslipData(result.data);
      setShowPayslipModal(true);
    } else {
      alert("❌ Failed to fetch payslip data.");
    }
  };
  const handleDownloadPayslip = async (employeeId, month) => {
    try {
      const response = await axios.get(
        `${Constant.BASE_URL}hrms/downloadPayslip`,
        {
          params: { employee_id: employeeId, month: month },
          responseType: "blob", // Important to get file as binary blob
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", `Payslip_${employeeId}_${month}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download payslip");
    }
  };
  return (
    <div className="AgentCustomer">
      <div className="container-fluid my-2">
        <div className="row">
          <main className="mainBodyContainer">
            <div
              className="bg-white p-4 shadow pb-5 rounded-3"
              style={{ marginLeft: "0.8rem", marginRight: "0.8rem" }}
            >
              <div className="d-flex justify-content-between border-bottom pb-3">
                <div className="bg-white">
                  <h4
                    className="text-capitalize icueTextPrimary"
                    style={{ fontFamily: "ErasDemiITC" }}
                  >
                    Calculate Salary
                  </h4>
                </div>
              </div>

              {!employeeData ? (
                <p className="text-danger">❌ No employee data found.</p>
              ) : (
                <div
                  className="multisteps-form__content"
                  style={{ fontFamily: "Calibri" }}
                >
                  <div className="row pt-4">
                    {/* Title */}

                    {/* Full Name */}
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-select text-uppercase bg-white text-muted"
                        value={`${employeeData?.first_name || ""} ${
                          employeeData?.last_name || ""
                        }`}
                        disabled
                      />
                    </div>

                    {/* Employee ID */}
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Employee ID
                      </label>
                      <input
                        type="text"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.employee_id || ""}
                        disabled
                      />
                    </div>

                    {/* Email */}
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.email || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Position
                      </label>
                      <input
                        type="text"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.joining_position || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Department
                      </label>
                      <input
                        type="text"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.department || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Contat Number
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.contact_number || ""}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className="bg-white p-4 shadow pb-5 rounded-3"
              style={{
                marginLeft: "0.8rem",
                marginRight: "0.8rem",
                marginTop: "20px",
              }}
            >
              <div className="d-flex justify-content-between border-bottom pb-3">
                <div className="bg-white"></div>
              </div>

              {!employeeData ? (
                <p className="text-danger">❌ No employee data found.</p>
              ) : (
                <div
                  className="multisteps-form__content"
                  style={{ fontFamily: "Calibri" }}
                >
                  <div className="row pt-4">
                    {/* Title */}

                    {/* Full Name */}
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Basic Salary
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.basic_salary || ""}
                        disabled
                      />
                    </div>

                    {/* Employee ID */}
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        HRA
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.hra || ""}
                        disabled
                      />
                    </div>

                    {/* Email */}
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Conveyance
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.conveyance || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Special Allowance
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.special_allowance || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Provident Fund
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.provident_fund || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        ESI
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.ESI || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Total CTC
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.ESI || ""}
                        disabled
                      />
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label
                        className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                        htmlFor="month"
                      >
                        Select Month
                      </label>
                      <input
                        type="month"
                        id="month"
                        className="form-select text-uppercase bg-white text-muted"
                        value={selectedMonth}
                        // onChange={(e) => setMonth(e.target.value)}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Total Work Days
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white"
                        value={employeeData?.work_days}
                        onChange={(e) => setWorkDays(e.target.value)}
                        placeholder="Enter total work days"
                      />
                    </div>

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Leave Days
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white"
                        value={employeeData.leave_days}
                        onChange={(e) => setLeaveDays(e.target.value)}
                        placeholder="Enter leave days"
                      />
                    </div>
                    {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Unpaid Leave
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white"
                        value={employeeData.unpaid_leave_days}
                        onChange={(e) => setunpaidLeaveDays(e.target.value)}
                        placeholder="Enter unpaidleave days"
                      />
                    </div> */}

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Leave Type
                      </label>
                      <select
                        className="form-select text-uppercase bg-white"
                        value={employeeData.leaveType}
                        onChange={(e) => setLeaveType(e.target.value)}
                      >
                        <option value="">Select leave type</option>
                        <option value="Casual Leave">Casual Leave</option>
                        <option value="Sick Leave">Sick Leave</option>
                        <option value="Paid Leave">Paid Leave</option>
                      </select>
                    </div>

                    {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                      <label className="form-label icueTextPrimary icueEmpInfoLabel mt-3">
                        Net Pay
                      </label>
                      <input
                        type="number"
                        className="form-select text-uppercase bg-white text-muted"
                        value={employeeData?.ESI || ""}
                        disabled
                      />
                    </div> */}
                  </div>{" "}
                  <button
                    className="btn btn-sm mt-4 p-1 px-3"
                    style={{
                      fontSize: "20px",
                      backgroundColor: "#3a3285",
                      color: "white",
                    }}
                    onClick={handleCalculateSalary}
                    disabled={!selectedMonth}
                  >
                    Calculate Salary
                  </button>
                  {employeeData ? (
                    <div className="mt-3">
                      <Button
                        variant=" "
                        style={{
                          backgroundColor: "#3a3285",
                          marginRight: "10px",

                          fontSize: "20px",
                        }}
                        onClick={() => {
                          if (!selectedMonth) {
                            alert("Please select a month first");
                            return;
                          }
                          handleDownloadPayslip(
                            employeeData.employee_id,
                            selectedMonth
                          );
                        }}
                      >
                        <i
                          className="bi bi-box-arrow-down"
                          style={{
                            cursor: "pointer",
                            color: "white",
                          }}
                          title="Download Payslip"
                        ></i>
                      </Button>
                      <Button
                        variant=" "
                        style={{
                          backgroundColor: "#3a3285",
                          color: "white",
                          fontSize: "20px",
                        }}
                        onClick={handleViewPayslip}
                      >
                        View Payslip
                      </Button>
                    </div>
                  ) : (
                    <p className="text-danger">❌ No employee data found.</p>
                  )}
                  <Modal
                    show={showPayslipModal}
                    onHide={() => setShowPayslipModal(false)}
                    size="lg"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Payslip Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {payslipData ? (
                        <ViewPayslip payslip={payslipData} />
                      ) : (
                        <p>Loading...</p>
                      )}
                    </Modal.Body>
                  </Modal>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default CalculateSalary;

// code in which i can see the payslip view when clicked on view paylsip btn
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Modal from "react-bootstrap/Modal";
// import ViewPayslip from "./ViewPayslip";

// function CalculateSalary() {
//   const location = useLocation();
//   const [workDays, setWorkDays] = useState("");
//   const [leaveDays, setLeaveDays] = useState("");
//   const [leaveType, setLeaveType] = useState("");
//   const [month, setMonth] = useState("July");

//   const [showPayslipModal, setShowPayslipModal] = useState(false);
//   const [payslipData, setPayslipData] = useState(null);

//   const passedEmployee = location.state?.employee?.employeeData;
//   const employeeId = passedEmployee?.employee_id;

//   const [employeeData, setEmployeeData] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("");

//   useEffect(() => {
//     if (passedEmployee) {
//       setEmployeeData(passedEmployee);
//       setSelectedStatus(passedEmployee.status || "");
//     }
//   }, [passedEmployee]);

//   const handleCalculateSalary = async () => {
//     if (!employeeData) return;

//     const payload = {
//       employee_id: employeeData.employee_id,
//       employee_name: `${employeeData.first_name} ${employeeData.last_name}`,
//       month: month,
//       base_salary: employeeData.basic_salary,
//       work_days: parseInt(workDays),
//       leave_days: parseInt(leaveDays),
//       hra: employeeData.hra,
//       conveyance: employeeData.conveyance,
//       special_allowance: employeeData.special_allowance,
//       pf: employeeData.provident_fund,
//       esi: employeeData.ESI,
//     };

//     try {
//       const response = await fetch(
//         "https://api.policicue.com/hrms/calculatePayroll",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       const result = await response.json();

//       if (result.status === 1) {
//         alert("✅ Salary calculated successfully!");
//         console.log("💰 Payroll Response:", result);

//         // ✅ Save to modal state
//         setPayslipData({
//           name: payload.employee_name,
//           employeeId: payload.employee_id,
//           designation: employeeData.joining_position,
//           month: payload.month,
//           salary: {
//             basic: payload.base_salary,
//             hra: payload.hra,
//             allowance: payload.special_allowance + payload.conveyance,
//             gross: result.gross_salary,
//             pf: payload.pf,
//             tax: result.tax || 0,
//             totalDeductions: result.total_deductions || 0,
//             netPay: result.net_pay,
//           },
//         });

//         setShowPayslipModal(true); // ✅ Open Modal
//       } else {
//         alert("❌ Failed to calculate salary.");
//       }
//     } catch (error) {
//       console.error("❌ Error while calling salary API:", error);
//       alert("Something went wrong.");
//     }
//   };
//   const staticPayslipEmployee = {
//     name: "John Doe",
//     employeeId: "EMP123",
//     designation: "Software Engineer",
//     month: "July 2025",
//     salary: {
//       basic: 30000,
//       hra: 10000,
//       allowance: 5000,
//       gross: 45000,
//       pf: 1800,
//       tax: 2500,
//       totalDeductions: 4300,
//       netPay: 40700,
//     },
//   };

//   return (
//     <div className="AgentCustomer">
//       <div className="container-fluid my-2">
//         <div className="row">
//           <main className="mainBodyContainer">
//             <div
//               className="bg-white p-4 shadow pb-5 rounded-3"
//               style={{ marginLeft: "0.8rem", marginRight: "0.8rem" }}
//             >
//               <h4 className="text-capitalize icueTextPrimary">
//                 Calculate Salary
//               </h4>

//               {!employeeData ? (
//                 <p className="text-danger">❌ No employee data found.</p>
//               ) : (
//                 <div className="multisteps-form__content">
//                   {/* Employee details here */}
//                 </div>
//               )}
//             </div>

//             <div
//               className="bg-white p-4 shadow pb-5 rounded-3"
//               style={{
//                 marginLeft: "0.8rem",
//                 marginRight: "0.8rem",
//                 marginTop: "20px",
//               }}
//             >
//               {!employeeData ? (
//                 <p className="text-danger">❌ No employee data found.</p>
//               ) : (
//                 <div className="multisteps-form__content">
//                   {/* Basic Salary field here */}

//                   {/* Buttons */}
//                   <button
//                     className="btn btn-sm mt-4 p-1 px-3"
//                     style={{
//                       fontSize: "20px",
//                       backgroundColor: "#3a3285",
//                       color: "white",
//                     }}
//                     onClick={() => setShowPayslipModal(true)}
//                   >
//                     View Payslip
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* ✅ Modal for Payslip */}
//             <Modal
//               show={showPayslipModal}
//               onHide={() => setShowPayslipModal(false)}
//               size="lg"
//             >
//               <Modal.Header closeButton>
//                 <Modal.Title>Employee Payslip</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <ViewPayslip employee={staticPayslipEmployee} />
//               </Modal.Body>
//             </Modal>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default CalculateSalary;

//code in which api integration of get payroll api is done
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";

// function ViewPayslip({ payslip }) {
//   return (
//     <div className="p-3">
//       <h5 className="mb-3">Payslip for {payslip.month}</h5>
//       <table className="table table-bordered">
//         <tbody>
//           <tr>
//             <th>Employee Name</th>
//             <td>{payslip.employee_name}</td>
//           </tr>
//           <tr>
//             <th>Employee ID</th>
//             <td>{payslip.employee_id}</td>
//           </tr>
//           <tr>
//             <th>Month</th>
//             <td>{payslip.month}</td>
//           </tr>
//           <tr>
//             <th>Base Salary</th>
//             <td>{payslip.base_salary}</td>
//           </tr>
//           <tr>
//             <th>HRA</th>
//             <td>{payslip.hra}</td>
//           </tr>
//           <tr>
//             <th>Conveyance</th>
//             <td>{payslip.conveyance}</td>
//           </tr>
//           <tr>
//             <th>Special Allowance</th>
//             <td>{payslip.special_allowance}</td>
//           </tr>
//           <tr>
//             <th>Gross Salary</th>
//             <td>{payslip.gross_salary}</td>
//           </tr>
//           <tr>
//             <th>PF</th>
//             <td>{payslip.pf}</td>
//           </tr>
//           <tr>
//             <th>ESI</th>
//             <td>{payslip.esi}</td>
//           </tr>
//           <tr>
//             <th>CTC</th>
//             <td>{payslip.ctc}</td>
//           </tr>
//           <tr>
//             <th>Work Days</th>
//             <td>{payslip.work_days}</td>
//           </tr>
//           <tr>
//             <th>Leave Days</th>
//             <td>{payslip.leave_days}</td>
//           </tr>
//           <tr>
//             <th>Unpaid Leave Days</th>
//             <td>{payslip.unpaid_leave_days}</td>
//           </tr>
//           <tr>
//             <th>Leave Type</th>
//             <td>{payslip.leave_type}</td>
//           </tr>
//           <tr>
//             <th>Total Deductions</th>
//             <td>{payslip.deductions}</td>
//           </tr>
//           <tr>
//             <th>Net Pay</th>
//             <td>{payslip.net_pay}</td>
//           </tr>
//           <tr>
//             <th>Generated On</th>
//             <td>{new Date(payslip.created_at).toLocaleString()}</td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// }

// function CalculateSalary() {
//   const location = useLocation();
//   const passedEmployee = location.state?.employee?.employeeData;
//   const [employeeData, setEmployeeData] = useState(null);
//   const [showPayslipModal, setShowPayslipModal] = useState(false);
//   const [payslipData, setPayslipData] = useState(null);
//   const [month] = useState("July");

//   useEffect(() => {
//     if (passedEmployee) {
//       setEmployeeData(passedEmployee);
//     }
//   }, [passedEmployee]);

//   const handleViewPayslip = async () => {
//     if (!employeeData) return;

//     const response = await fetch(
//       `https://api.policicue.com/hrms/viewPayslip?employee_id=${employeeData.employee_id}&month=${month}`
//     );
//     const result = await response.json();

//     if (result.status === 1) {
//       setPayslipData(result.data);
//       setShowPayslipModal(true);
//     } else {
//       alert("❌ Failed to fetch payslip data.");
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <h4>Calculate Salary</h4>
//       {employeeData ? (
//         <div className="mt-3">
//           <p>
//             <strong>Employee:</strong> {employeeData.first_name}{" "}
//             {employeeData.last_name}
//           </p>
//           <Button variant="primary" onClick={handleViewPayslip}>
//             View Payslip
//           </Button>
//         </div>
//       ) : (
//         <p className="text-danger">❌ No employee data found.</p>
//       )}

//       <Modal
//         show={showPayslipModal}
//         onHide={() => setShowPayslipModal(false)}
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Payslip Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {payslipData ? (
//             <ViewPayslip payslip={payslipData} />
//           ) : (
//             <p>Loading...</p>
//           )}
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }

// export default CalculateSalary;
